import { useApp } from '@/contexts';
import { isRumActive, setRumSessionAttributes } from '@/rum';

import { useEffect } from 'react';

/**
 * Attaches workspace context to the active RUM session (no PII).
 */
export const RumWorkspaceAttributes = () => {
  const { tenantId, appId } = useApp();

  useEffect(() => {
    if (!isRumActive()) return;

    const attributes: Record<string, string> = {};
    if (tenantId) attributes.tenantId = tenantId;
    if (appId) attributes.appId = appId;

    if (Object.keys(attributes).length > 0) {
      setRumSessionAttributes(attributes);
    }
  }, [tenantId, appId]);

  return null;
};
